<div class="dialog">
  <div mat-dialog-title>
    Create a Portfolio
    @if (!isAltWorkflow) {
      <span class="stepsProgressIndicator">Step 1 of 4</span>
    }
    <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
  </div>
  <mat-dialog-content>
    @if (portfolioNameInUse && portfolioIsActive) {
      <mat-card class="error block">
        <mat-card-title class="error">This name is already in use for a portfolio</mat-card-title>
        <mat-card-subtitle>Please enter a different name.</mat-card-subtitle>
      </mat-card>
    }
    @if (portfolioNameInUse && !portfolioIsActive && portfolioCanResurrect) {
      <mat-card class="error block">
        <mat-card-title class="warn">This is the name of a deleted portfolio</mat-card-title>
        <mat-card-subtitle>
          <div class="block">You can restore the deleted portfolio. If you do this, any rebalance and order history for the deleted portfolio will be linked to this portfolio. For example, if the deleted portfolio had a sale for a loss done in a taxable account within the last 30 days, this portfolio would not be able to buy that security until the wash sale period expires.</div>
          <div>If you do not want to restore the deleted portfolio, enter a new name for your new portfolio and continue.</div>
        </mat-card-subtitle>
      </mat-card>
    }
    @if (!portfolioNameInUse || portfolioNameInUse && portfolioIsActive) {
      <span>
        <div class="bottomPaddingElementDialog">{{callToActionText}}</div>
        <div>
          <label>Portfolio name:</label>
          <span tooltip [tooltipTitle]="tooltipMessage" tooltipClass="error" tooltipPosition="right"> <irb-validation-text-box #portfolioNameField  [(value)]="portfolioName" max="70" (change)="onInputChange()" regExp="^[a-zA-Z0-9\.]([a-zA-Z0-9,_\. \+\-\=\@]?)+$" invalidMessage="The value entered is not valid." width="320px" autofocus="true"></irb-validation-text-box></span>
        </div>
      </span>
    }
    @if (portfolioNameInUse && !portfolioIsActive && portfolioCanResurrect) {
      <span>
        <div class="block">
          <p-radioButton name="RestoreGroup" [value]="'Restore'"
            [(ngModel)]="resurrectOption"
            (onClick)="toggleNewPortfolioNameFormControl()"
          inputId="item1"></p-radioButton>
          <label for="item1">Restore deleted portfolio: {{restorePostfolioNames}}</label>
        </div>
        <div>
          <div class="block">
            <p-radioButton name="RestoreGroup" [value]="'New'"
              [(ngModel)]="resurrectOption" (onClick)="toggleNewPortfolioNameFormControl()"
            inputId="item2"></p-radioButton>
            <label for="item2">New Portfolio name:&nbsp;</label>
          </div>
          <span tooltip [tooltipTitle]="tooltipMessage" tooltipClass="error" tooltipPosition="right">
            <irb-validation-text-box #portfolioNameField max="70" [disabled]="portfolioNameRestore" [(value)]="portfolioName" (change)="onInputChange()"
            regExp="^[a-zA-Z0-9\.]([a-zA-Z0-9,_\. \+\-\=\@]?)+$" invalidMessage="The value entered is not valid." width="320px" autofocus="true"></irb-validation-text-box></span>
          </div>
        </span>
      }
    </mat-dialog-content>
    <mat-dialog-actions>
      <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
      @if (!continueShow) {
        <button id="continueButton"(click)="checkIfNameExists()" class="btn-medium-primary" [disabled]="canNotContinue">Continue</button>
      }
      @if (continueShow) {
        <button id="continueButton1" (click)="showAssignDialogPortfolio()" class="btn-medium-primary">Continue</button>
      }
    </mat-dialog-actions>
  </div>
